import React from "react";
import { compose, withAppContext, withActions, withState } from "containers/HOC";
import { matchPath } from "react-router-dom";
import { Form, Field } from "react-final-form";
import * as FormUtils from "common/FormUtils";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import TextareaPack from "components/TextareaPack";
import InputPack from "components/InputPack";
import { submitRequest, closeSupportModal } from "./_actions";

class AddSupportTicketModal extends React.Component {
    state = {};

    _validate = (values) => {
        const errors = {};

        errors.farmName = FormUtils.validators.maxLength(300)(values.farmName);

        errors.budgetName = FormUtils.validators.maxLength(300)(values.budgetName);

        errors.subject = FormUtils.validators.required(values.subject);
        errors.subject = errors.subject || FormUtils.validators.maxLength(100)(values.subject);

        errors.request = FormUtils.validators.required(values.request);
        errors.request = errors.request || FormUtils.validators.maxLength(1000)(values.request);

        return errors;
    };

    _save = (values) => {
        this.props.submitRequest(values, this.props.closeSupportModal);
    };

    render() {
        const { online, viewModel, closeSupportModal } = this.props;

        let body = viewModel.farmName ? `Farm: ${viewModel.farmName} ` : "";
        body += viewModel.budgetName ? ` | Analyses: ${viewModel.budgetName}` : "";

        return (
            <Form initialValues={viewModel} validate={this._validate} onSubmit={this._save}>
                {({ handleSubmit, submitSucceeded, dirty }) => {
                    return (
                        <Modal title="Create support request" onClose={closeSupportModal} instructions={viewModel.farmName ? "The farm and analysis have been populated for you. Please change these values if they are not relevant to the request." : ""}>
                            {({ closeModal }) => (
                                <form onSubmit={handleSubmit}>
                                    <ModalBody>
                                        <Grid>
                                            <GridCell className="u-width1of2">
                                                <Field name="farmName" className="u-mt-sm" label="Farm" placeholder="Farm name if applicable" type="text" component={InputPack} />
                                            </GridCell>
                                            <GridCell className="u-width1of2">
                                                <Field name="budgetName" className="u-mt-sm" label="Analysis" placeholder="Analysis name if applicable" type="text" component={InputPack} />
                                            </GridCell>
                                            <GridCell>
                                                <Field name="subject" label="Subject" placeholder="Enter the subject of the request" required type="text" component={InputPack} />
                                            </GridCell>
                                            <GridCell>
                                                <Field name="url" type="hidden" component="input" />
                                                <Field name="request" label="Request" placeholder="Enter the details for your request." requiredLabel={true} component={TextareaPack} />
                                                <div className="u-mt-md">
                                                    Alternatively you can email support at <a href={`mailto:support@overseer-helpdesk.zendesk.com?body=${body}`}>support@overseer-helpdesk.zendesk.com</a>
                                                </div>
                                            </GridCell>
                                        </Grid>
                                    </ModalBody>
                                    <ModalFooter>
                                        <div className="ButtonBar">
                                            <div className="ButtonBar-left">
                                                <button id="cancel-button" type="button" className="Button Button--secondary" onClick={closeSupportModal}>
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button id="save-button" type="submit" className="Button" disabled={!online || !dirty || submitSucceeded}>
                                                    Send
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </form>
                            )}
                        </Modal>
                    );
                }}
            </Form>
        );
    }
}
export default compose(
    withAppContext,
    withActions({ submitRequest, closeSupportModal }),
    withState((state, ownProps) => {
        const params = new URLSearchParams(ownProps.location.search);
        const from = params.get("from");

        const budgetLocation = matchPath(from, { path: "/app/farm/:farmId/analysis/:budgetId" });
        const farmLocation = budgetLocation ? undefined : matchPath(from, { path: "/app/farm/:farmId" });
        const farmId = budgetLocation ? budgetLocation.params.farmId : farmLocation ? farmLocation.params.farmId : undefined;
        const budgetId = budgetLocation ? budgetLocation.params.budgetId : undefined;
        const offlineFarm = state.offlineFarms.find((f) => f.id === farmId);
        const offlineBudget = offlineFarm && offlineFarm.farm ? (offlineFarm.farm.offlineBudgets || []).find((b) => b.id === budgetId) : null;

        return {
            modal: state.support.modal,
            viewModel: {
                farmName: offlineFarm ? offlineFarm.farm.name : undefined,
                budgetName: offlineBudget ? offlineBudget.budget.name : undefined,
                url: budgetLocation ? budgetLocation.url : farmLocation ? farmLocation.url : undefined,
            },
        };
    })
)(AddSupportTicketModal);
